import React, { Component, Fragment } from 'react';
import "moment/locale/es";
import moment from 'moment';

class FragmentsOldsQuerysAndProcedures extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
            <hr />
                {this.props.data.completo !== "" && this.props.data.completo !== null ?
                    <Fragment>
                        <p> {this.props.data.completo}</p>
                    </Fragment>
                    : null}
            </>
        );
    }
}

export default FragmentsOldsQuerysAndProcedures;
